import React from 'react'
import NoticeModal from '@/components/NoticeModal'

export default function MigratedTips({ onOk }: { onOk: () => void }) {
  return (
    <NoticeModal
      title="提示"
      visible={true}
      closable={false}
      onOk={onOk}
      okText="确定"
    >
      <div>
        <div>
          用户你好，平台正在推进服务升级，需要迁移到代运维平台进行运营，将为您带来更好的体验
        </div>
        <div>
          <div>如果您是【周结】</div>
          <div>1. 历史钱包余额未提现部分，请到新平台提现</div>
          <div>2. 6月9日及之后的账单，请到新平台查看</div>
        </div>
        <div>
          <div>如果您是【月结】</div>
          <div>1. 历史钱包余额未提现部分，请到新平台提现</div>
          <div>2. 6月1日及之后的金额在次月入账，到新平台提现</div>
        </div>
      </div>
    </NoticeModal>
  )
}
